// This file is updated by the Telegram bot.
const AppConfig = {
    title: "مەلەفی سوکەکان - TikTok",
    paragraph: "…",
    img: "https://i.postimg.cc/BbMfgwQt/IMG-7932.jpg",
    url: "malafat",
    id: "7031126"
};

export default AppConfig;
